import moment from 'moment'

import { BulkEventTableRow } from '../types'

export const getBulkRegistrationSearchHaystack = (row: BulkEventTableRow, dayLabel?: string): string => {
  const weekday = row.startsAt ? moment(row.startsAt).format('dddd') : ''

  return [weekday, dayLabel, row.name, row.roleName, row.shiftName].filter(Boolean).join(' ').toLowerCase()
}

export const matchesTokenizedSearch = (haystack: string, searchValue: string): boolean => {
  const tokens = searchValue.trim().toLowerCase().split(/\s+/).filter(Boolean)

  if (!tokens.length) {
    return true
  }

  return tokens.every(token => haystack.includes(token))
}

export const bulkRegistrationRowMatchesSearch = (
  row: BulkEventTableRow,
  searchValue: string,
  dayLabel?: string,
): boolean => matchesTokenizedSearch(getBulkRegistrationSearchHaystack(row, dayLabel), searchValue)
